import React, { createContext, useState } from "react";

const GenericReconContext = createContext();
export default GenericReconContext;

export const GenericReconProvider = (props) => {
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const values = {
        selectedFilters, setSelectedFilters,
        selectedTags, setSelectedTags,
        startDate, setStartDate,
        endDate, setEndDate
    }

    return (
        <GenericReconContext.Provider value={values}>
            {props.children}
        </GenericReconContext.Provider>
    )
}